import SectionHead from "./SectionHead";

export default function Intro() {
  return (
    <section id="intro" className="bg-[#fff8f0] py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          eyebrow="01 · 它是什么"
          title="一句话先回答你"
          desc="先给你一个能秒懂的定义，再看后面的细致拆解，避免一头雾水。"
        />

        <div className="mt-10 overflow-hidden rounded-3xl bg-white ring-1 ring-orange-100 shadow-soft">
          <div className="grid items-stretch lg:grid-cols-[1fr_auto]">
            <div className="p-7 md:p-10">
              <p className="text-xl leading-relaxed text-stone-700 md:text-2xl">
                「53吃瓜」本质是互联网圈里的一种{" "}
                <mark className="font-medium">“围观 + 跟进”表达</mark>
                ：当一件事足够热门、剧情还在发酵时，大家用这句话表达
                “先不站队、搬好小板凳、盯着看后续”。
              </p>
              <p className="mt-5 text-base leading-relaxed text-stone-500">
                它继承了“吃瓜群众”的看戏底色，又叠加了一层带“代号感”的圈内默契。
                无论写成 53吃瓜 还是 五三吃瓜，读起来传达的都是同一种轻松又热切的围观心情。
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {["网络流行语", "吃瓜文化", "圈内代号", "围观现象"].map((t) => (
                  <span
                    key={t}
                    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-emerald-50 px-3 py-1.5 text-xs font-medium text-emerald-700"
                  >
                    <i className="ri-checkbox-circle-line" aria-hidden="true" />
                    {t}
                  </span>
                ))}
              </div>
            </div>
            <div className="relative hidden w-full max-w-sm items-center justify-center p-8 lg:flex">
              <img
                src="https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20relaxed%20young%20person%20sitting%20with%20laptop%20and%20drink%20watching%20a%20big%20screen%20of%20spinning%20gossip%20headlines%20and%20hot%20tags%2C%20curious%20and%20playful%20mood%2C%20warm%20cream%20background%2C%20coral%20red%20and%20mint%20green%20and%20orange%20palette%2C%20clean%20minimal%20modern%20illustration&width=800&height=640&seq=intro-watch-53-02&orientation=landscape"
                alt="围观热搜的年轻网友插画"
                title="53吃瓜围观场景插画"
                className="h-auto w-full rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>

        {/* 三个定位卡 */}
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-3xl bg-white p-6 ring-1 ring-orange-100 transition-transform hover:-translate-y-1">
            <div className="grid h-11 w-11 place-items-center rounded-xl bg-rose-100 text-xl text-rose-600">
              <i className="ri-eye-line" aria-hidden="true" />
            </div>
            <h3 className="mt-4 text-lg font-bold text-stone-800">它是什么</h3>
            <p className="mt-2 text-sm leading-relaxed text-stone-500">
              一种轻松的社交信号词，表示“这个热闹值得看、我先蹲着等更新”，不站队、不轻信。
            </p>
          </div>
          <div className="rounded-3xl bg-white p-6 ring-1 ring-orange-100 transition-transform hover:-translate-y-1">
            <div className="grid h-11 w-11 place-items-center rounded-xl bg-emerald-100 text-xl text-emerald-600">
              <i className="ri-close-circle-line" aria-hidden="true" />
            </div>
            <h3 className="mt-4 text-lg font-bold text-stone-800">它不是什么</h3>
            <p className="mt-2 text-sm leading-relaxed text-stone-500">
              不是造谣工具、不是网暴口号。它只表达围观姿态，真正重要的是理性看事、以事实为准。
            </p>
          </div>
          <div className="rounded-3xl bg-white p-6 ring-1 ring-orange-100 transition-transform hover:-translate-y-1">
            <div className="grid h-11 w-11 place-items-center rounded-xl bg-orange-100 text-xl text-orange-600">
              <i className="ri-group-line" aria-hidden="true" />
            </div>
            <h3 className="mt-4 text-lg font-bold text-stone-800">谁在用</h3>
            <p className="mt-2 text-sm leading-relaxed text-stone-500">
              常年活跃在热门评论区、群聊与弹幕里的年轻网民，是“吃瓜圈”里的通用打招呼语。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}